<script lang="ts" module>
  import HelpButton, { type HelpTargetProps } from '../../buttons/HelpButton.svelte';

  export interface FooterMoreActionsProps {
    helpTarget?: HelpTargetProps;
    label: string;
    onInfoClick?: () => void;
    infoText?: string;
  }
</script>

<script lang="ts">
  let {
    infoText: infoTextProp,
    onInfoClick: onInfoClickProp,
    ...props
  }: FooterMoreActionsProps = $props();
</script>

<div class="grid gap-2">
  <hr class="border-t-c-divider" />
  <div class="text-right">
    {#if props.helpTarget}
      <HelpButton {...props.helpTarget} label={props.label} />
    {/if}
    {#if infoTextProp}
      <p class="text-left font-sans text-xs font-normal text-c-base">
        {infoTextProp}
      </p>
    {/if}
  </div>
</div>
